<template>
  <div class="box" id="DocManage">
    <div class="left-box">
      <div class="head-box">
        <h4>文档管理{{ type == '7' ? '（功能管理）' : '' }}</h4>
        <div class="c-flex">
          <!-- v-if="!treeData.length" -->
          <i
            class="el-icon-circle-plus-outline c-pointer c-m-l-15"
            @click="
              editOrg = {};
              orgDialog = true;
            "
          ></i>
        </div>
      </div>
      <div class="left-content tree">
        <el-tree
          refs="tree"
          ref="tree"
          :data="treeData"
          node-key="_id"
          default-expand-all
          :indent="20"
          highlight-current
          :expand-on-click-node="false"
          @node-click="treeClick"
          :props="defaultProps"
          :current-node-key="expandedkeys"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <el-tooltip
              v-if="data.state == 99"
              class="item"
              effect="dark"
              content="系统生成菜单不可编辑"
              placement="top-end"
            >
              <i class="el-icon-info c-m-r-10"></i>
            </el-tooltip>
            <span style="font-size: 14px">
              {{ data.name }}
              <div class="wp">
                <i
                  :class="`${activeOrg._id == data._id ? '' : 'isShow'} el-icon-edit c-pointer`"
                  @click="treeEdit(data)"
                  v-if="data.state != 99"
                ></i>
                <i
                  :class="
                    `${activeOrg._id == data._id ? '' : 'isShow'} el-icon-delete c-pointer c-m-l-15`
                  "
                  @click="treeDelete(data)"
                  v-if="data.state != 99"
                ></i>
                <i
                  v-if="data.state != 99"
                  class="el-icon-circle-plus-outline c-pointer c-m-l-15"
                  @click="treeAdd(data)"
                ></i>
              </div>
            </span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="服务团队"
                placement="top-start"
              ></el-tooltip>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <el-dialog title="文档菜单" :visible.sync="orgDialog" width="500px">
      <el-form :model="editOrg">
        <template v-if="type == '7'">
          <el-form-item label="文档类型名称" label-width="100px">
            <el-cascader
              placeholder="请选择功能菜单"
              v-model="editOrg.exts.functionIds"
              ref="functions"
              :options="functions"
              @change="functionChange"
              :props="{
                expandTrigger: 'hover',
                children: 'functionList',
                checkStrictly: true,
                value: '_id',
                label: 'name'
              }"
            ></el-cascader>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="文档类型名称" label-width="100px">
            <el-input v-model="editOrg.name"></el-input>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="treeSave(editOrg)">确 定</el-button>
        <el-button @click="orgDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <div class="right-box">
      <div class="head-box">
        <h4>文档信息列表{{ type == '7' ? '（步骤）' : '' }}</h4>
        <div class="c-flex">
          <el-input
            placeholder="请输入"
            v-model="searchValue"
            clearable
            @clear="
              fpi.page = 1;
              getData();
            "
            @keyup.enter.native="
              fpi.page = 1;
              getData();
            "
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click.native="
                fpi.page = 1;
                getData();
              "
            ></el-button>
          </el-input>
          <!-- <el-button type="primary" class="c-m-l-10">批量导入</el-button> -->
          <el-button
            type="primary"
            class="c-m-l-10"
            @click.native="documentAdd"
            v-if="activeOrg.state != 99"
          >
            新建文档
          </el-button>
          <el-button class="c-m-l-10" @click.native="removeList" v-if="activeOrg.state != 99">
            批量删除
          </el-button>
        </div>
      </div>
      <div class="content-box">
        <div class="content-table">
          <el-table
            ref="table"
            :data="fpi.data"
            empty-text="暂无信息"
            height="calc(100% - 50px)"
            @selection-change="handleSelectionChange"
            highlight-current-row
          >
            <!-- {{scope.row.state==99}} -->
            <el-table-column
              type="selection"
              width="55"
              v-if="activeOrg.state != 99"
            ></el-table-column>

            <el-table-column fixed="right" width="100px" v-if="activeOrg.state != 99">
              <template slot-scope="scope" v-if="scope.row.state != 99">
                <el-dropdown>
                  <el-button>
                    操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="documentEdit(scope.row, false)">
                      编辑
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="documentDelete(scope.row)">
                      删除
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>

            <el-table-column :label="type == 7 ? '文档内容' : '文档名称'" width="240" fixed="left">
              <template slot-scope="scope">
                <el-button type="text" @click.native.prevent="documentEdit(scope.row, true)">
                  {{ scope.row.title }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="createUserName" label="创建人" width="180"></el-table-column>
            <el-table-column prop="createTime" label="创建日期" width="180"></el-table-column>
            <el-table-column prop="updateUserName" label="最新编辑人" width="180"></el-table-column>
            <el-table-column prop="updateTime" label="最新编辑日期" width="180"></el-table-column>
            <el-table-column label="附件数量" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.fileids.length || 0 }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="pageSizeChange"
            @current-change="pageChange"
            :current-page="fpi.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="fpi.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="fpi.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="文档信息" :visible.sync="userDialog" width="650px">
      <el-form
        :model="editUser"
        ref="user"
        :rules="rules"
        label-width="100px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="选择分类" prop="categoryId">
          <el-cascader
            v-model="editUser.categoryId"
            :options="treeDataOptions"
            :props="{
              value: '_id',
              label: 'name',
              children: 'childrens',
              checkStrictly: true
            }"
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>
        <el-form-item :label="type == '7' ? '文档内容' : '文档名称'" prop="title">
          <el-input
            autosize
            :type="type == '7' ? 'textarea' : ''"
            v-model="editUser.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <el-upload
            :action="upload.url"
            :data="upload.data"
            :file-list="editUser.fileList"
            multiple
            :limit="upload.limit"
            :on-exceed="osg.uploadExceed"
            :before-upload="
              file => {
                return beforeUpload(file, 'max100');
              }
            "
            :on-success="
              (response, file, fileList) => {
                // return osg.uploadSuccess(response, file, fileList, 'image');
                return (editUser.fileList = fileList);
              }
            "
            :on-error="osg.uploadError"
            :on-remove="
              (file, fileList) => {
                return beforeRemove(file, fileList, 'fileList');
              }
            "
            :on-preview="uploadPreview"
          >
            <el-button size="small">
              <i class="el-icon-upload"></i>
              点击上传
            </el-button>
            <div slot="tip" class="el-upload__tip">附件文件大小不能超过100MB</div>
            <!--
            <li class="el-upload-list__item is-success" slot="file" slot-scope="{file}">
              <a class="el-upload-list__item-name">
                <i class="el-icon-document"></i>file.name
              </a>
              <label class="el-upload-list__item-status-label">
                <i class="el-icon-upload-success el-icon-circle-check"></i>
              </label>
              <i class="el-icon-close" @click="beforeRemove(file, fileList)"></i>
              <i class="el-icon-close-tip">按 delete 键可删除</i>
            </li>
            -->
          </el-upload>
        </el-form-item>
        <c-editor
          v-if="type != '7'"
          :formData="editUser"
          :value="'content'"
          ref="editor"
        ></c-editor>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="documentSave()">确 定</el-button>
        <el-button @click="userDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="文档信息"
      id="documentShowDialog"
      :visible.sync="documentShowDialog"
      width="650px"
    >
      <!-- <div class="showCell">
        <span>分类：</span>
        <span>{{ editUser.categoryId }}</span>
      </div> -->
      <div class="showCell">
        <span>文档{{ type == 7 ? '内容' : '名称' }}：</span>
        <span>{{ editUser.title }}</span>
      </div>
      <div class="showCell">
        <span>附件列表</span>
      </div>
      <div class="showCell">
        <el-table :data="editUser.fileList" border size="small">
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <a v-show="scope.row.url" :href="scope.row.url" target="_blank">查看</a>
              <span v-show="!scope.row.url">暂无地址</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="附件名称"></el-table-column>
        </el-table>
      </div>
      <div class="showCell" v-if="type != '7'">
        <span>文档内容：</span>
        <span v-html="editUser.content"></span>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="documentShowDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'DocManage',
  inject: ['displayWizard'],
  data() {
    window.$this = this;
    return {
      tenantID: '', //租户id
      activeTab: 'org', //当前激活tab
      orgDialog: false,
      activeOrg: '', //当前选中菜单树
      editOrg: { exts: {} }, //当前编辑的菜单树
      treeData: [], //所有菜单树节点
      defaultProps: {
        children: 'childrens',
        label: 'name'
      },
      userDialog: false, //是否显示编辑
      documentShowDialog: false, //展示信息
      searchValue: '', //搜索关键词
      fpi: {}, //问题信息列表
      editUser: {}, //编辑信息
      edit: false, //新增false 编辑true
      rules: {
        categoryId: [
          {
            required: true,
            message: '分类不能为空',
            trigger: ['blur', 'change']
          }
        ],
        title: [
          {
            required: true,
            message: '文档名称不能为空',
            trigger: 'blur'
          }
        ],
        content: [
          {
            required: true,
            message: '解答(A)内容不能为空',
            trigger: 'blur'
          }
        ]
      },
      treeDataOptions: [], //选择文档分类,
      delList: [], //批量信息列表
      formatterTypeArr: [], //反显信息表的分类,
      // 富文本编辑器
      vqeditor: {
        content: '',
        editorOption: {
          theme: 'snow',
          placeholder: '请输入文档内容',
          modules: {
            // imageDrop:true,  //拖拽上传
            // ImageResize: {},
            //图片调整大小
            // ImageExtend: {
            //   loading: true,
            //   name: 'image',
            //   size: 2,
            //   action: `/api/file/upload/image?filePath=${JSON.stringify(this.imagePath)}`,
            //   response: (res) => {
            //     return res.data
            //   }
            // },
            // imageResize: {},
            //工具栏
            toolbar: [
              ['bold', 'italic', 'underline' /* , 'strike' */], //加粗，斜体，下划线，删除线
              // ['blockquote', 'code-block'],  //引用，代码块
              [
                {
                  header: 1
                },
                {
                  header: 2
                }
              ], // 标题，键值对的形式；1、2表示字体大小
              [
                {
                  list: 'ordered'
                },
                {
                  list: 'bullet'
                }
              ], //列表
              [
                {
                  align: []
                }
              ], //对齐方式
              // [{ 'script': 'sub'}, { 'script': 'super' }], // 上下标
              // [{ 'indent': '-1'}, { 'indent': '+1' }],  // 缩进
              // [{ 'direction': 'rtl' }],    // 文本方向
              // [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
              // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],  //几级标题
              [
                {
                  color: []
                },
                {
                  background: []
                },
                {
                  font: []
                }
              ], // 字体颜色，字体背景颜色，字体
              ['clean'], //清除字体样式
              ['link', 'image' /* ,'video' */] //上传图片、上传视频
            ]
            //图片大小调整
            /* ImageExtend: {
          loading: true,
          name: 'image',
          size: 2,
          action: `/api/file/upload/image?filePath=${JSON.stringify(this.imagePath)}`,
          response: (res) => {
            return res.data
          }
        }, */
          }
        }
      },
      expandedkeys: '', //默认选中菜单树
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 5
      },
      type: 2, //2文档、7新手向导
      functions: [] //菜单列表
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.tenantID = JSON.parse(sessionStorage['entity']).tenantId;
    this.type = this.$route.query.type || 2;
    this.getTree();
    this.osg.getFpi();
    this.getData();
    if (this.type == 7) this.getFunctionData();
    // this.displayWizard({ colName: 'ServiceAppointments', show: true });//测试
  },
  methods: {
    //页码变更
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    //当前页变更
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    //添加树
    treeAdd(data) {
      if (this.isSeveral(data) >= 3) {
        this.osg.toast('只允许创建三级目录！', 'warning');
        return;
      } else {
        this.editOrg = { exts: {} };
        this.orgDialog = true;
      }
    },
    //点击菜单树
    treeClick(obj) {
      this.activeOrg = this.$util.deepCopy(obj);
      console.log(this.activeOrg);
      this.getData();
    },
    //获取文档树
    getTree() {
      this.osg.ajax('documentCategory/query.do', { type: this.type }, res => {
        let data = [res.entity];
        this.treeData = data;
        this.treeDataOptions = this.removeEmpty(
          res.entity && res.entity.childrens ? res.entity.childrens : []
        );
        this.treeDataOptions = this.treeDataOptions.filter(item => item.state != 99);
        this.$nextTick(() => {
          //给菜单树设置默认值
          this.expandedkeys = this.activeOrg._id || res.entity._id;
          this.activeOrg = { _id: this.expandedkeys };
          this.$refs.tree.setCurrentKey(this.expandedkeys);
        });

        this.formatterTypeArr = [];
        this.myFlat(this.treeDataOptions);
      });
    },
    //编辑菜单树
    treeEdit(data) {
      if (this.isSeveral(data) == 1) {
        this.osg.toast('根目录不能进行编辑！', 'warning');
        return;
      }
      this.editOrg = this.activeOrg;
      this.orgDialog = true;
    },
    //新手向导菜单更改事件
    functionChange() {
      //getCheckedNodes 组件原生方法，获取选中的节点
      this.editOrg.name = this.$refs.functions.getCheckedNodes()[0].data.name; //获取当前选择的数据赋值name
      this.editOrg.exts = this.editOrg.exts || {};
      this.editOrg.exts.action = this.$refs.functions.getCheckedNodes()[0].data.action; //新手向导的菜单路径
    },
    // 保存菜单树
    treeSave() {
      if (!this.editOrg.name) {
        this.osg.toast('请输入菜单名称！', 'error');
        return;
      }
      var org = this.editOrg;
      org.parentId = org.parentId || this.activeOrg._id || 0;
      org.tenantId = this.tenantID;
      org.type = this.type;
      delete org.childrens;
      this.osg.ajax('documentCategory/upsert.do', { data: JSON.stringify(org) }, res => {
        this.osg.toast('保存成功！');
        this.orgDialog = false;
        this.getTree();
      });
    },
    // 删除空数组
    removeEmpty(arr, childrens = 'childrens') {
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          if (item[childrens] ? item[childrens].length === 0 : false) {
            delete item[childrens];
          } else {
            this.removeEmpty(item, childrens);
          }
        });
        return arr;
      }
    },
    // 判断当前被选中的节点在第几层数组
    isSeveral(obj) {
      return this.treeData
        .map(item => {
          if (item._id == obj._id) {
            return 1;
          }
          return !item.childrens
            ? []
            : item.childrens.map(ele => {
                if (ele._id == obj._id) {
                  return 2;
                }
                return !ele.childrens
                  ? []
                  : ele.childrens.map(el => {
                      if (el._id == obj._id) {
                        return 3;
                      }
                    });
              });
        })
        .flat(Infinity)
        .join('');
    },
    // 解析菜单
    myFlat(arr) {
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          this.formatterTypeArr.push(item);
          if (item.childrens ? item.childrens.length : false) {
            this.formatterTypeArr.push(...item.childrens);
          }
        });
      }
    },
    //删除菜单节点
    treeDelete(data) {
      if (this.isSeveral(data) == 1) {
        this.osg.toast('根目录不能删除 ！', 'warning');
        return;
      } else {
        this.osg.confirm(`是否确认删除"${this.activeOrg.name}"`, () => {
          this.osg.ajax(`documentCategory/remove/${this.activeOrg._id}.do`, {}, res => {
            this.osg.toast('删除成功！');
            this.searchValue = '';
            this.getTree();
            this.getData();
          });
        });
      }
    },
    //获取列表
    getData() {
      var params = {
        'regex:title|string#and': this.searchValue,
        'is:type|integer#and': this.type,
        'is:categoryId|string#and':
          this.isSeveral(this.activeOrg) == 1 ? '' : this.activeOrg._id || '',
        sortField: 'createTime',
        sortOrder: 'desc',
        page: this.fpi.page,
        rows: this.fpi.rows
      };
      this.osg.setFpi(params);
      this.osg.ajax('document/query.do', params, res => {
        if (res) {
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
        }
      });
    },
    //获取菜单
    getFunctionData() {
      this.osg.ajax('login/main.do', {}, res => {
        res.data.currentFun.functionList = this.osg.removeEmpty(
          res.data.currentFun.functionList || [],
          'functionList'
        );
        this.functions = res.data.currentFun.functionList;
      });
    },
    //添加信息按钮
    documentAdd() {
      this.edit = false;
      this.editUser = {};
      this.editUser.categoryId = this.activeOrg._id;
      this.userDialog = true;
    },
    //编辑信息按钮
    documentEdit(row, isShow) {
      if (row.fileids && row.fileids.length) {
        row.fileList = row.fileids.map(item => {
          //item格式为 uuid_要展示的名字.文件扩展名，有_取_后面的，没有返回整个
          let showName = item.indexOf('_') != -1 ? item.substr(item.indexOf('_') + 1) : item;
          return { url: this.upload.downloadUrl + item, name: showName };
        });
      }
      if (isShow) {
        this.editUser = this.$util.deepCopy(row);
        this.documentShowDialog = true;
        return;
      }
      this.edit = true;
      this.editUser = this.$util.deepCopy(row);
      this.userDialog = true;
    },
    //保存信息
    documentSave() {
      let pass;
      this.$refs['user'].validate(valid => {
        if (valid) pass = true;
      });
      if (!pass) return;

      if (this.editUser.fileList && this.editUser.fileList.length) {
        this.editUser.fileids = this.editUser.fileList.map(item => {
          if (item.response) {
            return item.response.key;
          } else if (item.url) {
            let reg = new RegExp(this.upload.downloadUrl, 'g');
            return item.url.replace(reg, '');
          }
        });
      }
      let editUser = this.$util.deepCopy(this.editUser);
      editUser.type = this.type;
      editUser.tenantId = this.tenantID;
      delete editUser.fileList;
      editUser.categoryId = Array.isArray(editUser.categoryId)
        ? editUser.categoryId[editUser.categoryId.length - 1]
        : editUser.categoryId;
      this.osg.ajax('document/upsert.do', editUser, res => {
        this.osg.toast('保存成功');
        this.userDialog = false;
        this.getData();
      });
    },
    //删除文档信息
    documentDelete(row) {
      this.osg.confirm('是否确认删除 ' + row.title + '？', () => {
        this.osg.ajax(`document/remove/${row._id}.do`, null, res => {
          this.osg.toast('删除成功！');
          this.getData();
        });
      });
    },
    //批量删除
    removeList() {
      this.osg.confirm('是否确认删除 ？', () => {
        let state = true;
        let dataArr = this.delList.map(item => {
          if (item.state == 99) state = false;
          return item._id;
        });
        if (!state) {
          this.osg.toast('选中文档包含系统生成的档案，导致不能删除！', 'warning');
          return;
        }
        this.osg.ajax(
          'document/batchRemove.do',
          { dList: JSON.stringify(dataArr) },
          res => {
            if (res) {
              this.osg.toast('删除成功！');
              this.getData();
              this.getTree();
            }
          }
          // { header: { "Content-Type": "application/json" } }
        );
      });
    },
    //被勾选上的问题信息列表
    handleSelectionChange(val) {
      this.delList = val;
    },
    formatterType(row, column, cellValue, index) {
      return this.formatterTypeArr
        .map(item => {
          if (item._id == cellValue) return item.name;
        })
        .join('');
    },
    beforeRemove(file, fileList, field) {
      let list = this.editUser[field];
      let listIds = this.editUser.fileids;
      let reg = new RegExp(this.upload.downloadUrl, 'g');
      let keyStr = '';
      if (file.url) {
        keyStr = file.url.replace(reg, '');
        let removeIndex = list.findIndex(item => item.url == file.url);
        let removeIndexIds = listIds.findIndex(item => item == keyStr);
        if (removeIndex != -1) list.splice(removeIndex, 1);
        if (removeIndexIds != -1) listIds.splice(removeIndexIds, 1);
      } else if (file.response) {
        let removeIndex = list.findIndex(item =>
          item.response ? item.response.key == file.response.key : false
        );
        let removeIndexIds = listIds.findIndex(item => item == file.response.key);

        if (removeIndex != -1) list.splice(removeIndex, 1);
        if (removeIndexIds != -1) listIds.splice(removeIndexIds, 1);
      }
      if (keyStr) {
        this.osg.ajax(`back/super/file/delete/${keyStr}.do`, null, res => {}, {
          method: 'GET'
        });
      }
    },
    doImgSave() {
      let params = this.$util.deepCopy(this.editUser);
      params.fileList.map(item => {
        if (item.url.indexOf('blob:') != -1) {
          item.url = this.upload.downloadUrl + item.response.key;
        }
      });
      params.fileList = JSON.stringify(params.fileList);
      this.$util.saveExtField(this.extFields, params);
    },
    uploadPreview(file) {
      file.url ? window.open(file.url) : window.open(this.upload.downloadUrl + file.response.key);
    },
    async beforeUpload(file, format) {
      if (format == 'image') {
        //format = image 表示只允许上传图片
        const isImage =
          file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
        // const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isImage) {
          this.osg.toast('上传头像图片只能是 JPG/PNG/GIF 格式!', 'error');
          return false;
        }
      } else if (format == 'excel') {
        const isExcel = file.name.split('.')[1] === 'xls' || file.name.split('.')[1] === 'xlsx';
        if (!isExcel) {
          this.osg.toast('上传模板只能是 xls、xlsx格式!', 'error');
          return false;
        }
      } else if (format == 'max100') {
        const isLt100M = file.size / 1024 / 1024 < 100;
        if (!isLt100M) {
          this.osg.toast('附件文件大小不能超过100MB', 'error');
          return false;
        }
      }
      await new Promise(resolve => {
        this.osg.ajax(
          'document/getQiniuUpToken.do',
          {
            fileName: file.name
          },
          res => {
            this.upload.data = res;
            resolve();
          },
          {
            noload: true
          }
        );
      });
    }
  },
  $route() {
    // window.$this = this;
    // this.type = this.$route.query.type || 2;
    // this.getTree();
    // this.osg.getFpi();
    // this.getData();
    // if (this.type == 7) this.getFunctionData();
  }
};
</script>
<style scoped>
a {
  color: #409eff;
}
.showCell {
  margin: 0 40px 10px 10px;
  display: flex;
  align-items: center;
}
.showCell > span:nth-of-type(1) {
  width: 80px;
  line-height: 30px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}
.isShow {
  display: none;
}
.wp {
  position: absolute;
  top: 50%;
  right: 36px;
  transform: translateY(-50%);
}
</style>
<style>
#DocManage .el-tree-node__content {
  position: relative;
}
#DocManage .el-dialog {
  height: auto !important;
}
</style>
